/**
 * ContactProtect — enthüllt verschleierte Kontaktlinks (E-Mail / Telefon).
 *
 * Im HTML steht weder Adresse noch Nummer als Klartext: die Werte liegen
 * base64-kodiert in data-enc / data-label. Erst im Browser wird daraus das
 * echte href (mailto:/tel:) und der sichtbare Linktext gebaut. Harvester, die
 * kein JS ausführen, sehen nichts Brauchbares; der Klick funktioniert normal.
 *
 * Markup (vom Server gerendert):
 *   <a href="#" data-contact="mailto" data-enc="<b64>" data-label="<b64>">…</a>
 *   data-contact: "mailto" | "tel"
 */
export function initContactProtect() {
    const links = document.querySelectorAll('a[data-contact][data-enc]');

    for (const el of links) {
        const scheme = el.dataset.contact === 'tel' ? 'tel:' : 'mailto:';

        let value = '';
        let label = '';
        try {
            value = atob(el.dataset.enc);
            label = el.dataset.label ? atob(el.dataset.label) : value;
        } catch (e) {
            continue; // kaputter Wert -> Link unangetastet lassen
        }

        el.setAttribute('href', scheme + value);
        el.textContent = label;

        // Klartext-Reste aus dem DOM entfernen
        el.removeAttribute('data-enc');
        el.removeAttribute('data-label');
    }
}
